import styled from 'styled-components';
import { ReactComponent as Icon } from '../../assets/excel-file-svgrepo-com.svg';
import { tint } from 'polished';

interface VariantStyleProps {
  cor: string;
}

interface VariantProps {
  [key: string]: VariantStyleProps;
}

const variants: VariantProps = {
  report: {
    cor: '#00BFFF',
  },
  graph: {
    cor: '#FFA500',
  },
  default: {
    cor: '#32CD32',
  },
};

function getVariant(key?: string): VariantStyleProps {
  if (!key) {
    return variants.default;
  }

  return variants[key] || variants.default;
}

export const StyledIcon = styled(Icon)<{ variant?: string }>`
  fill: ${props => getVariant(props.variant).cor};
`;

export const Card = styled.div<{ variant?: string; haveSettings: boolean }>`
  border: 2px solid ${props => getVariant(props.variant).cor};

  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;

  width: 300px;

  background: white;

  cursor: normal;

  div:first-child {
    display: flex;
    align-items: center;
    justify-content: center;

    padding: 10px;
    height: 100%;

    background: ${props => getVariant(props.variant).cor};

    svg {
      color: white;
      height: 45px;
      width: 45px;
    }
  }

  div:nth-child(2) {
    padding: 5px;
    color: ${props => getVariant(props.variant).cor};

    h2 {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 5px;
    }

    p {
      font-size: 14px;
    }
  }

  div:nth-child(3) {
    cursor: pointer;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 5px;

    color: ${props => getVariant(props.variant).cor};
    height: 100%;

    svg {
      width: 22px;
      height: 22px;

      &:hover {
        color: ${props => tint(0.6, getVariant(props.variant).cor)};
      }
    }
  }
`;
